const copy = {
  messageErrorsPresent: {
    headers: {
      messageStatusHeader: (
        lastNDays: number
      ) => `We've found that there are issues with your message deliverability
      over the past ${lastNDays} days.`,
      viewIssuesBy: "View issues by:",
    },
    callToAction: {
      troubleshoot: "I have a message to troubleshoot",
    },
    messageStatusCopy: (
      failedMessages: number,
      undeliveredMessages: number,
      percentMessagesFailed: string
    ) => {
      return (
        <>
          Your account has <b>{failedMessages}</b> failed messages and{" "}
          <b>{undeliveredMessages}</b> undelivered messages, constituting{" "}
          {percentMessagesFailed} of your total message traffic. Would you like
          to learn more about the root causes?
        </>
      );
    },
  },
  noMessageErrorsPresent: {
    headers: {
      messageStatusHeader: "Great news!",
      viewIssuesBy: "View issues by:",
      sampleQuestions: "Sample questions",
    },
    callToAction: {
      commonMessageErrors: "What are the common message errors?",
      deliverabilityScore: "What is Deliverability Score?",
      deliveredVersusFailed: "What are undelivered vs. failed status?",
    },
    messageStatusCopy: (
      lastNDays: number
    ) => `Your account doesn't have messaging deliverability errors in the last 
      ${lastNDays} days.`,
    haveQuestions: "Have questions? Feel free to ask-I'm here to assist!",
  },
};

export default copy;
